import { FC } from "react";

import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { AddressType, IPredictionQuestion, PredictionQuestionResult } from "@framework/types";
import ERC721SimpleSetDefaultRoyaltyABI from "@framework/abis/json/ERC721Simple/setDefaultRoyalty.json";
import { IOnConfirmArgs } from "@dzambalaorg/react-hooks";

import { validationSchema } from "./validation";

export interface IPredictionQuestionViewDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IPredictionQuestion;
}

export const PredictionResultDialog: FC<IPredictionQuestionViewDialogProps> = props => {
  const { viewItem, onConfirm, ...rest } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFn } = useMetamask(async (values: IPredictionQuestion) => {
    return writeContractAsync({
      address: "values.contract.address" as AddressType,
      abi: ERC721SimpleSetDefaultRoyaltyABI,
      functionName: "resolve",
      args: [values.id, values.questionResult],
    });
  });

  const handleResolve = async ({ data }: IOnConfirmArgs<IPredictionQuestion>): Promise<void> => {
    await metaFn(data).finally(() => {
      onConfirm();
    });
  };

  return (
    <FormDialog
      initialValues={viewItem}
      validationSchema={validationSchema}
      message="dialogs.resolve"
      testId="PredictionQuestionReolveForm"
      disabled={false}
      onExternalConfirm={handleResolve}
      {...rest}
    >
      <SelectInput name="questionResult" options={PredictionQuestionResult} />
    </FormDialog>
  );
};
